import Layout from '@/components/layout/Layout.vue'
import DataForm from '@/views/sys/sys-log/data/Data.vue'
import { getSysLogs } from "@/api/sys-log"

const columns = [
    { title: '账号', dataIndex: 'username' },
    { title: '姓名', dataIndex: 'name' },
    { title: '钉钉昵称', dataIndex: 'nick' },
    { title: 'IP归属', scopedSlots: {customRender: 'ip'} },
    { title: '操作时间', dataIndex: 'created_at' },
    { title: '操作行为', scopedSlots: { customRender: 'remark' } },
]

export default {
    name: 'sys_logs',
    components: {
        Layout,
        DataForm
    },
    data () {
        return {
            data: [],
            pagination: {
                defaultPageSize: 20,
                showSizeChanger: true,
                onShowSizeChange: this.pageSizeChange,
                pageSizeOptions: ['10', '20', '30', '40', '60', '80', '100'],
                showTotal: (total) => {
                    return ' 共 ' + total + ' 条'
                },
            },
            loading: false,
            columns,
            model: {},
            showDataForm: false,
            queryParam: {}
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        showData(record) {
            this.model = Object.assign({}, record)
            this.showDataForm = true
        },
        handleTableChange(pagination) {
            const pager = { ...this.pagination }
            pager.current = pagination.current
            this.pagination = pager
            this.getData()
        },
        getData() {
            this.loading = true
            const pagination = { ...this.pagination }
            const json = Object.assign({}, this.queryParam, {
                page: pagination.current,
                page_size: pagination.defaultPageSize
            })
            if (json.date && json.date.length > 0) {
                json.started_at = json.date[0].format('YYYY-MM-DD')
                json.finished_at = json.date[1].format('YYYY-MM-DD')
                delete json.date
            }
            getSysLogs(json).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list
                this.pagination = pagination
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.pagination.current = 1
            this.getData()
        },
        resetSearch() {
            this.queryParam = {}
            this.getData()
        },
    }
}
